import React from "react";
import Helmet from "react-helmet";
import Layout from "../components/layout";
// import Lightbox from 'react-images'

import Gallery from "../components/Gallery";

import full01 from "../assets/images/fulls/Branded-Rock-Identity.jpg";
import full02 from "../assets/images/fulls/Branded Rock Canyon - Home.png";
import full03 from "../assets/images/fulls/Branded Rock Canyon - Shooting Sports.png";


import thumb01 from "../assets/images/fulls/Branded-Rock-Identity.jpg";
import thumb02 from "../assets/images/fulls/Branded Rock Canyon - Home.png";
import thumb03 from "../assets/images/fulls/Branded Rock Canyon - Shooting Sports.png";



const DEFAULT_IMAGES = [
  {
    id: "1",
    source: full01,
    thumbnail: thumb01,
  },
  {
    id: "2",
    source: full02,
    thumbnail: thumb02,
  },
  {
    id: "3",
    source: full03,
    thumbnail: thumb03,
  },
];

const SportsConnect = () => (
  <Layout>
           <Helmet>
          <title>Andy Miller - Branded Rock Canyon</title>
        </Helmet>
        <div id="main">
    <h1>Branded Rock Canyon</h1>
    <p>I designed a proof-of-concept rebrand and website for the luxury guest ranch, Branded Rock Canyon. The main goal of the design was to create a unique style that characterized the two key words, “luxury ranch”. With a lighter site, rustic color palette, serif font, and a focus on high quality imagery, this design greatly improved the identity of Branded Rock Canyon.</p>
    <Gallery
              images={DEFAULT_IMAGES.map(
                ({ id, source, thumbnail, caption, description }) => ({
                  source,
                  thumbnail,
                })
              )}
            />
    </div>
  </Layout>
);

export default SportsConnect;
